import { useLoaderData } from "@remix-run/react";
import {
  getProductV2Service,
  productAtom,
  ProductDetailsResponse,
} from "core/catalog";
import { publicRoutes } from "framework/config/middlewares";
import { productMeta } from "framework/routes";
import { ProductDetailsPage } from "~/modules/product-details/pages";

export const meta = productMeta;

export const loader = publicRoutes(async ({ http, params, success }) => {
  const { id } = params;

  const response = await getProductV2Service(http, id as string);

  return success(response);
});

export default function ProductDetails() {
  const data = useLoaderData<ProductDetailsResponse>();

  productAtom.update(data);

  return <ProductDetailsPage />;
}
